<template>
  <div
    v-if="collectionMeta.promoVideoOnly && collectionMeta.promoVideo"
    class="in-grid-banner in-grid-banner--video critical-component-clear"
  >
    <video-element
      :poster="bannerImage"
      :src="collectionMeta.promoVideo"
    />
  </div>

  <div
    v-else
    class="in-grid-banner critical-component-clear"
    :style="`background-image: url(${bannerImage})`"
  >
    <div
      class="in-grid-banner__content"
    >
      <h3
        class="in-grid-banner__header"
        :style="`color: ${collectionMeta.promoHeaderColor}`"
        v-text="collectionMeta.promoHeader"
      />

      <btn
        class="in-grid-banner__button"
        modifiers="text"
        :show-icon="false"
        :label="collectionMeta.promoCtaLabel"
        :style="{color: collectionMeta.promoCtaColor}"
        @click="handleCtaClick"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: In grid banner (in-grid-banner)
 * -----------------------------------------------------------------------------
 * Promo blocks that can be inserted into collection templates.
 * - Static section.
 *
 * @param {Object} collectionMeta - Meta information from collection object.
 *
 */

import breakpoints from '~/config/breakpoints'
import Btn from '~global/btn/btn'
import VideoElement from '~global/video-element/video-element'

export default {
  name: 'InGridBanner',

  components: {
    Btn,
    VideoElement,
  },

  props: {
    collectionMeta: {
      type: Object,
      default: () => null,
    },
  },

  emits: 'section-mounted',

  computed: {

    /**
     * Returns the correct image based on available screen size.
     */
    bannerImage() {
      let image = this.collectionMeta.promoMobileImage

      if (window.screen.availWidth > Number(breakpoints.l.replace('px', ''))) {
        image = this.collectionMeta.promoDesktopImage
      }

      return image
    },
  },

  mounted() {
    this.$emit('section-mounted')
  },

  methods: {

    /**
     * Handle CTA click - open Shop the Look or proceed to link url.
     */
    handleCtaClick() {
      const {
        promoLink,
        promoShopTheLook,
        promoShopTheLookCollection,
      } = this.collectionMeta

      if (promoShopTheLook && promoShopTheLookCollection !== null) {
        window.cnvs.EventBus.emit('shop-the-look', {
          collection: promoShopTheLookCollection,
        })

        return
      }

      window.location = promoLink
    },
  },
}
</script>

<style lang="scss">
@import './in-grid-banner';
</style>
